import { of } from "rxjs";
import { switchMapTo } from "rxjs/operators";
import { ofType } from "redux-observable";
import { hubDisconnect } from "@dux/hub";
import { smartBridgeReset } from "@dux/smartBridge";

export const APPLOCK_ENGAGE = "pss/appLock/ENGAGE";
export const APPLOCK_ACTION_ACTIVATED = "pss/appLock/ACTION_ACTIVATED";
export const APPLOCK_CLEAR = "pss/appLock/CLEAR";
export const APPLOCK_CLEAR_ALL = "pss/appLock/CLEAR_ALL";

const initialState = {
  activeLocks: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case APPLOCK_ENGAGE:
      return {
        ...state,
        activeLocks: {
          ...state.activeLocks,
          [action.payload.id]: action.payload,
        },
      };
    case APPLOCK_CLEAR:
      let locks = { ...state.activeLocks };
      delete locks[action.payload];
      return {
        ...state,
        activeLocks: locks,
      };
    case APPLOCK_CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}

export function appLockEngage({ id, localKey, icon, variant, actions }) {
  const hydratedActions = actions.map((action, idx) => ({
    id: idx,
    localKey: "Action",
    buttonProps: {
      color: "primary",
      variant: "contained",
    },
    ...action,
  }));
  return {
    type: APPLOCK_ENGAGE,
    payload: { id, localKey, icon, variant, actions: hydratedActions },
  };
}

export function appLockActionActivated(lockId, action) {
  return { type: APPLOCK_ACTION_ACTIVATED, payload: { lockId, action } };
}

export function appLockClear(lockId) {
  return { type: APPLOCK_CLEAR, payload: lockId };
}

export function appLockClearAll() {
  return { type: APPLOCK_CLEAR_ALL };
}

export function appLockEngageEpic(action$) {
  return action$.pipe(
    ofType(APPLOCK_ENGAGE),
    switchMapTo(of(hubDisconnect(), smartBridgeReset()))
  );
}

export const appLockEpics = [appLockEngageEpic];
